jQuery(document).ready(function($) {
    var observ_form = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            var img = $('.shopify-product-form img.roomvo-stimr');
            if (img.length) {
                //hide image if appear
                img.hide();
                var link = $('span.nw-roomvo-crosslink');
                    if (link.length) {
                      $('.nw-cross-links-section').addClass('two-cols-50'); 
                      $('.nw-cross-links-section').removeClass('horisontal-style');
                      $('.nw-roomvo-box').addClass('active');
                    }      
                // stop observ_form
                observ_form.disconnect();
            }
        });
    });
    var targetNodes = document.getElementsByClassName('shopify-product-form');    
    if (targetNodes.length > 0) {
        observ_form.observe(targetNodes[0], {
            childList: true, //if new item appear
            subtree: true  
        });
    }
  
    $('span.nw-roomvo-crosslink').on('click', function() {
        $('.shopify-product-form img.roomvo-stimr').click();
    });
});


$(document).ready(function() {
      var sliderContainer = $('.nw-cross-sell-slider-wrap');
      var flktyNwCrossSellSlider = null;
      
      function nwCrossSellSlider() {
        var containerWidth = sliderContainer.width();
        var totalItemsWidth = 36;
        sliderContainer.find('.cross-sell-slider-item').each(function() {
          totalItemsWidth += $(this).outerWidth();
        });
              console.log('totalItemsWidth ',totalItemsWidth);
              console.log('containerWidth ',containerWidth);
        if (totalItemsWidth > containerWidth) {
          if (flktyNwCrossSellSlider === null) {
            sliderContainer.removeClass('no-slider');
              flktyNwCrossSellSlider = new Flickity(sliderContainer[0], {
                cellAlign: 'center',
                contain: true,
                wrapAround: true,
                autoPlay: false,
                prevNextButtons: true,
                pageDots: false,
                draggable: true
              });
              
              var currentProduct = sliderContainer.find('.current-product');
                if (currentProduct.length) {
                  var currentProductIndex = currentProduct.index();
                  if (currentProductIndex !== -1) {
                    setTimeout(function() {
                      flktyNwCrossSellSlider.select(currentProductIndex);
                    }, 500);
                  }
                       
              }
          }
        } else {
            if (flktyNwCrossSellSlider) {
              flktyNwCrossSellSlider.destroy();
              flktyNwCrossSellSlider = null;
            }
            sliderContainer.addClass('no-slider');
        }
    }
    nwCrossSellSlider();
    $(window).resize(function() {
      nwCrossSellSlider();
    });
});